import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-mapbox-wrapper';

/**
 * HouseMarker Functional Component.
 */
function HouseMarker({ ...rest }) {
    return (
        <Marker anchor="bottom" {...rest}>
            <svg width="43" height="56" data-house-marker>
                <g fill="none" fillRule="evenodd">
                    <path
                        d="M21.38 56s21.378-22.814 21.378-34.62C42.758 9.57 33.186 0 21.378 0 9.573 0 0 9.572 0 21.38 0 33.185 21.38 56 21.38 56z"
                        fill="#1e91ff"
                    />
                    <path
                        fill="#FFF"
                        d="M19.968 29.016H15V21h-3l9.984-9 9.984 9h-3v8.016H24v-6h-4.032"
                    />
                </g>
            </svg>
        </Marker>
    );
}

HouseMarker.displayName = 'HouseMarker';

HouseMarker.propTypes = {
    coordinates: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }).isRequired,
    map: PropTypes.shape({}).isRequired,
};

export default HouseMarker;
